import { Button, Box, Text } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Heading } from '@vibe/core';

type DeleteWidgetModalProps = {
  show: boolean;
  isUnpublishing: boolean;
  onClose: (doDelete: boolean) => void;
};

export function DeleteWidgetModal({ show, onClose, isUnpublishing }: DeleteWidgetModalProps) {
  return (
    <AppModal
      contentSpacing={false}
      alertDialog={true}
      data-testid="deleteWidgetModal"
      width={300}
      show={show}
      onClose={() => {
        onClose(false);
      }}
    >
      <AppModalContent>
        <Box marginBottom="large">
          <Heading type="h3" weight="bold" align="start" style={{ marginBottom: '10px' }}>
            Unpublish widget
          </Heading>
          <Text type="text2" align="start" color="secondary" element="p">
            By unpublishing this widget, all stored board data outside of monday.com will be removed permanently and the widget will no
            longer be publicly accessible.
          </Text>
        </Box>

        <Box marginBottom="medium">
          <Button
            disabled={isUnpublishing}
            size="medium"
            kind="primary"
            color="negative"
            onClick={async () => {
              onClose(true);
            }}
            style={{
              width: '100%',
            }}
          >
            Unpublish widget
          </Button>
        </Box>
      </AppModalContent>
    </AppModal>
  );
}
